import { notification } from 'antd';
import { ArgsProps } from 'antd/lib/notification';

const defaultOptions = {
  duration: 10,
};

const OmniNotification = {
  success: (args: ArgsProps) => {
    notification.success({ ...defaultOptions, ...args });
  },
  error: (args: ArgsProps) => {
    notification.error({ ...defaultOptions, ...args });
  },
  info: (args: ArgsProps) => {
    notification.info({ ...defaultOptions, ...args });
  },
};

export default OmniNotification;
